import React, { useRef, useState, useEffect } from 'react';
import { DEFAULT_API_URL } from '../constents';
import uploadfiles from './handleUploadFiles';
import setUiMessage from './Tostify';

function UploadFile({ fileArr, handleReturnFileArr, isScan = false }) {
  const fileInputRef = useRef(null);
  const [finalFile, setFinalFile] = useState(fileArr);
  const handleRemoveAttachFile = (file) => {
    const newAttachArr = fileArr;
    newAttachArr.splice(file, 1);
    setFinalFile(newAttachArr);
    handleReturnFileArr(newAttachArr);
  };

  useEffect(() => {
    setFinalFile(fileArr);
  }, [fileArr]);

  const handleCameraClick = () => {
    fileInputRef.current.setAttribute('capture', 'camera');
    fileInputRef.current.click();
    fileInputRef.current.removeAttribute('capture');
  };

  const handleBrouseClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const apiUrl = `${DEFAULT_API_URL}/api/patient/ManagePriorAuth/uploadImage`;
      const responce = await uploadfiles(apiUrl, file);
      if (responce.data?.successCode === 'success') {
        handleReturnFileArr([
          ...finalFile,
          {
            fileName: responce.data?.fleName,
            filePath: responce.data?.flePathName,
          },
        ]);
        setFinalFile([
          ...finalFile,
          {
            fileName: responce.data?.fleName,
            filePath: responce.data?.flePathName,
          },
        ]);
      }
    } else {
      setUiMessage('err', 'Please select file');
    }
  };

  return (
    <div className="insu-act-sec-bdy-lft flex-sec">
      <span className="nsu-act-lbl">Upload:</span>
      <span
        className="nsu-act-val"
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className="width100"
          style={{
            paddingBottom: '10px',
            marginTop: '5px',
          }}
        >
          <span
            className="actn-yes"
            style={{
              width: 'unset',
              padding: '3px 12px',
              marginLeft: '0px',
              float: 'left',
            }}
            onClick={handleCameraClick}
          >
            Camera
          </span>
          <span
            className="actn-yes"
            style={{
              width: 'unset',
              padding: '3px 12px',
              float: 'left',
            }}
            onClick={handleBrouseClick}
          >
            Browse
          </span>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileSelect}
          />
          {isScan && (
            <span
              className="actn-yes"
              style={{
                width: 'unset',
                padding: '3px 12px',
                float: 'left',
              }}
            >
              Scan
            </span>
          )}
        </div>
        <div className="width100">
          {finalFile &&
            finalFile.map((item, i) => (
              <div
                className=""
                style={{
                  paddingBottom: '10px',
                }}
                key={i}
              >
                <span className="">
                  <a
                    href={item?.filePath}
                    target="blank"
                    className=""
                    style={{
                      margin: '5px 0px 0px 0px',
                    }}
                  >
                    {item?.fileName}
                  </a>
                </span>
                <span
                  className="bold red clear-left10"
                  onClick={() => handleRemoveAttachFile(i)}
                >
                  [X]
                </span>
              </div>
            ))}
        </div>
      </span>
    </div>
  );
}

export default UploadFile;
